import React from 'react';
import StarRating from 'common/components/star_rating';

const StarRatingPartial = ({ rating }) => {
  return (
    <div className="star-rating-partial">
      <div className="full-rating-wrapper" style={{ width: `calc(${parseFloat(rating)*100/5}% + 0.5px)` }}>
        <StarRating initialRate={5} readonly={true} extraClasses="xl" />
      </div>
      <StarRating initialRate={0} readonly={true} extraClasses="xl" />
    </div>
  );
}

export default StarRatingPartial;



// WEBPACK FOOTER //
// ./marketing/components/star_rating_partial.jsx